import api from '@/constant/END_POINT'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'
import { RejectClaimResponse } from './type'

const fetchRejectClaim = async (claimId: string) => {
  const response = await httpClientPrivate.get<RejectClaimResponse>(
    api.backoffice.rejectPreview(claimId),
  )

  return response.data
}

const useRejectClaim = (claimId: string) => {
  const query = useQuery({
    queryKey: ['useRejectClaim', claimId],
    queryFn: async () => fetchRejectClaim(claimId),
  })
  return { ...query }
}

export { useRejectClaim }
